import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { SelectModule } from 'src/app/common-components/entity-select/select/select.module';
import { PhoneIssuesChipAndMenuModule } from 'src/app/common-components/phone-issues-chip-and-menu/phone-issues-chip-and-menu.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { ExtensionGroupRegisterComponent } from './containers/extension-group-register.component';
import { ExtensionGroupRegisterEffects } from './state/extension-group-register.effects';
import {
   extensionGroupRegisterFeatureKey,
   extensionGroupRegisterReducer,
} from './state/extension-group-register.reducer';
import { ExtensionGroupRegisterViewComponent } from './views/extension-group-register-view.component';

@NgModule({
   declarations: [ExtensionGroupRegisterComponent, ExtensionGroupRegisterViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      SelectModule,
      LcsCallStatePipeModule,
      PhoneIssuesChipAndMenuModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      MatMenuModule,
      MatCheckboxModule,
      ReactiveFormsModule,
      RouterModule,
      MatMenuModule,
      RegisterModule,
      ScrollingModule,
      EntitySelectModule,
      EffectsModule.forFeature([ExtensionGroupRegisterEffects]),
      StoreModule.forFeature(extensionGroupRegisterFeatureKey, extensionGroupRegisterReducer),
   ],
})
export class ExtensionGroupRegisterModule {}
